const boardStatus = {
    INACTIVE: 0,
    ACTIVE: 1,
    ARCHIVED: 2
}
const boardType = {
    STANDARD: 0,
    MEMBER: 1,
    VIP: 2,
    EDITOR: 3,
    MODERATOR: 4,
    ADMIN: 5,
    COREADMIN: 6,
    NEWS: 7
}
const topicStatus = {
    DELETED: 0,
    PENDINGAPPROVAL: 1,
    NORMAL: 2,
    MODERATED: 3,
    LOCKED: 4
}
const postStatus = {
    DELETED: 0,
    PENDINGAPPROVAL: 1,
    APPROVED: 2,
    DENIED: 3
}

export default {
    boardStatusEnum: boardStatus,
    boardTypeEnum: boardType,
    topicStatusEnum: topicStatus,
    postStatusEnum: postStatus
}

